import type { JSX } from 'react';

import { cn } from '../lib/cn.js';
import { LiaHead } from './LiaHead.js';

/**
 * L'AVATAR DE LIA (V3-6 du 07/10/2026) : la tete de la mascotte, le meme
 * dessin que dans la liste des conversations (`LiaHead`), sur son rond lime.
 * UN seul composant partout ou Lia a un avatar (fil de la fenetre, sujets de
 * Lia, Canaux, liste de mentions) : jamais d'initiale « L ».
 */
export function AvatarLia({ size, className }: { size: number; className?: string | undefined }): JSX.Element {
  return <span aria-hidden="true" data-avatar-lia=""
    className={cn('inline-flex shrink-0 items-center justify-center rounded-full bg-accent text-accent-label', className)}
    style={{ width: `${size / 16}rem`, height: `${size / 16}rem` }}><LiaHead size={Math.round(size * 0.56)} /></span>;
}
